<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-title">
        <div class="icon" @click="goBack">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
        </div>
        注册精英机构/基地帐号
      </div>
      <div class="page-airticle">
        <vue-scroll>
          <div class="scroll-content">
            <el-form
              ref="regionForm"
              :model="regionForm"
              :rules="regionFormRules"
              label-width="220px"
            >
              <el-form-item label="精英机构/基地类型" prop="level">
                <el-select
                  v-model="regionForm.level"
                  placeholder="请选择精英机构/基地类型"
                  class="w_input"
                >
                  <!-- <el-option label="中超" value="中超" />
                  <el-option label="中甲" value="中甲" />
                  <el-option label="中乙" value="中乙" />
                  <el-option label="中冠" value="中冠" />
                  <el-option label="学校" value="学校" />
                  <el-option label="体校" value="体校" />
                  <el-option label="其他" value="其他" /> -->
                  <el-option
                    label="社会足球培训机构"
                    value="社会足球培训机构"
                  />
                  <el-option label="足球学校" value="足球学校" />
                  <el-option label="体校" value="体校" />
                  <el-option label="普通学校" value="普通学校" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
              <el-row :gutter="10" class="provinceSettingTra">
                <div class="label">精英机构/基地所属区域</div>
                <!-- <el-col :span="5" style="margin-right: 20px">
                  <el-form-item label-width="0" prop="provinceCode">
                    <el-select
                      v-model="regionForm.provinceCode"
                      placeholder="请选择省"
                      @change="changeProvince"
                    >
                      <el-option
                        v-for="item in regions"
                        :key="item.code"
                        :value="item.code"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="5" style="margin-right: 20px">
                  <el-form-item label-width="0" prop="cityCode">
                    <el-select
                      v-model="regionForm.cityCode"
                      placeholder="请选择市"
                      clearable
                      @change="changeCity"
                    >
                      <el-option
                        v-for="item in select_city_list"
                        :key="item.code"
                        :value="item.code"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label-width="0" prop="countyCode">
                    <el-select
                      v-model="regionForm.countyCode"
                      placeholder="请选择区"
                      clearable
                      @change="changeCounty"
                    >
                      <el-option
                        v-for="item in sh_county_list"
                        :key="item.code"
                        :value="item.code"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="管理单位" prop="organUuid">
                <el-select
                  v-model="regionForm.organUuid"
                  placeholder="请选择管理单位"
                  clearable
                  class="w_input"
                  @change="changeOrg"
                >
                  <el-option
                    v-for="(item, index) in youthSelectList"
                    :key="index"
                    :value="item.uuid"
                    :label="item.organShortName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

<!--              <el-form-item label="俱乐部全称" prop="youthName">-->
<!--                <el-input-->
<!--                  v-model.trim="regionForm.youthName"-->
<!--                  class="w_input"-->
<!--                  placeholder="请输入俱乐部全称(50个字以内)"-->
<!--                ></el-input>-->
<!--              </el-form-item>-->

              <el-form-item label="全称" prop="youthName">
                <el-select v-model="regionForm.youthName" filterable placeholder="请选择精英机构/基地" class="w_input">
                  <el-option
                    v-for="item in clubOptions"
                    :key="item.id"
                    :label="item.clubName"
                    :value="item.clubName">
                  </el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="简称" prop="youthShortName">
                <el-input
                  v-model.trim="regionForm.youthShortName"
                  class="w_input"
                  placeholder="请输入精英机构/基地简称(20个字以内)"
                ></el-input>
              </el-form-item>



              <el-form-item label="管理员姓名" prop="idName">
                <el-input
                  v-model.trim="regionForm.idName"
                  class="w_input"
                  placeholder="请输入管理员姓名"
                ></el-input>
              </el-form-item>

              <el-form-item label="手机号" prop="phone" :error="phoneError">
                <el-input
                  v-model.trim="regionForm.phone"
                  class="w_input"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>

              <el-form-item label="统一社会信用码（登录名）" prop="loginName">
                <el-input
                  v-model.trim="regionForm.loginName"
                  class="w_input"
                  placeholder="请输入统一社会信用码(作为登录帐号)"
                ></el-input>
              </el-form-item>

              <el-form-item label="密码" prop="pwd">
                <el-input
                  v-model="regionForm.pwd"
                  class="w_input"
                  type="password"
                  show-password
                  auto-complete="new-password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="确认密码" prop="cPwd">
                <el-input
                  v-model="regionForm.cPwd"
                  class="w_input"
                  type="password"
                  show-password
                  auto-complete="new-password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="图形验证码"
                :error="photoCodeError"
                prop="photoCode"
              >
                <div class="photocode-box">
                  <div class="left">
                    <el-input
                      v-model.trim="regionForm.photoCode"
                      placeholder="请输入图形验证码"
                    ></el-input>
                  </div>
                  <div class="right">
                    <img
                      :src="verificationBase64"
                      v-show="!showLoading"
                      @load="showLoading = false"
                    />
                    <div class="loadImgIng" v-show="showLoading">
                      <i class="el-icon-loading loading-code"></i>
                    </div>
                    <div
                      v-show="!showLoading"
                      class="refresh-code"
                      @click="loadPhotoCode"
                    >
                      看不清，换一张
                    </div>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="手机验证码" prop="accessCode">
                <div class="accesscode-bvox">
                  <div class="left">
                    <el-input
                      v-model.trim="regionForm.accessCode"
                      placeholder="请输入验证码"
                    ></el-input>
                  </div>
                  <div class="right">
                    <div
                      class="code-btn"
                      :class="{ 'code-btn-disabled': !canSendCode }"
                      @click="sendPhoneCode"
                    >
                      <span v-if="canSendCode">发送验证码</span>
                      <span v-else>{{ lastSec }}s后重新发送</span>
                    </div>
                    <el-tooltip placement="right" effect="light">
                      <div slot="content" class="no_code_method">
                        <p>解决办法</p>
                        <p>
                          1:
                          通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；
                        </p>
                        <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                        <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                        <p>
                          4: 关机后重新启动手机，重新加载手机和基站的通信链路；
                        </p>
                        <p>5: 联系电话客服；</p>
                      </div>
                      <div class="code-err-tips">收不到验证码？</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="page-footer">
        <el-button type="primary" @click.stop="handlePageAdd">注册</el-button>
        <el-button type="danger" @click="handleCancel">取消</el-button>
      </div>

      <template v-if="isShowAddConfirm">
        <yioks-tips
          :showTip="isShowAddConfirm"
          tipMsg="请确认提交？"
          :loading="repeatSubmit"
          @callback="hideTipsDialog"
        ></yioks-tips>
      </template>
      <template v-if="isShowCancelConfirm">
        <yioks-tips
          :showTip="isShowCancelConfirm"
          tipMsg="确认离开吗？"
          @callback="handleConfirmCancel"
        ></yioks-tips>
      </template>

      <template v-if="isShowSuccessBack">
        <el-dialog
          title="提示"
          :visible.sync="isShowSuccessBack"
          width="480px"
          top="30vh"
          :close-on-click-modal="false"
          custom-class="yioks-success-dialog"
        >
          <div class="success-wrapper">
            <img :src="success" class="icon-img" alt="" />
            <div class="text">帐号注册成功！准备跳转登录页。</div>
            <div class="action-box">
              <div class="btn" @click="handleJumpForSuccess">跳转</div>
            </div>
          </div>
        </el-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import regions from "@/utils/regions";
import { uuid } from "@/assets/js/utils";
import common from "@/api/common";
import { requiredItem } from "@/assets/js/formRules";
import { isIdNumber } from "@/assets/js/formRules"
import mixinAddressForSH from "@/mixin/mixinAddressForSH";
import success from "@/assets/images/common/success.png";
import yioksRules from "@/utils/formRules/rules";
import auth from "@/api/auth";
import JSEncrypt from "@/assets/js/jsencrypt.min.js";
const defaultSec = 60;

export default {
  mixins: [mixinAddressForSH],
  components: {
    "yioks-tips": () => import("@/components/YioksTip"),
  },
  data() {
    return {
      ops,
      regions,
      success,
      cityList: [],
      regionForm: {
        provinceCode: "31",
        provinceName: "上海市",
        cityCode: "",
        cityName: "",
        countyCode: "",
        countyName: "",
        youthName: "",
        youthShortName: "",
        level: "",
        idName: "",
        loginName: "",
        phone: "",
        photoCode: "",
        accessCode: "",
        pwd: "",
        cPwd: "",
      },
      selectOrganList: [],

      showLoading: true,
      verificationBase64: "", // 图片
      photoCodeError: "",
      canImgRefresh: true,
      lastSec: defaultSec,
      canSendCode: true,
      phoneError: "",
      isShowAddConfirm: false,
      repeatSubmit: false,

      youthSelectList: [],
      isShowCancelConfirm: false,
      isShowSuccessBack: false,

      clubOptions: [],
      value: ''
    };
  },

  computed: {
    nonce_str() {
      const res = uuid();
      return res;
    },
    regionFormRules() {
      return {
        //  provinceCode: [ requiredItem('管理单位'), ],
        cityCode: [requiredItem("市", true)],
        countyCode: [requiredItem("区", true)],
        organUuid: [requiredItem("管理单位", true)],
        youthName: [requiredItem("精英机构/基地全称")],
        youthShortName: [requiredItem("精英机构/基地简称")],
        level: [requiredItem("精英机构/基地类型", true)],
        idName: [requiredItem("管理员姓名")],
        loginName: [requiredItem("统一社会信用码"), true],
        phone: [requiredItem("手机号")],
        photoCode: [requiredItem("图形验证码")],
        accessCode: [requiredItem("手机验证码")],
        pwd: [
          requiredItem("密码"),
          {
            validator: (rule, val, cb) => {
              const { pwd, cPwd } = this.regionForm;
              if (val) {
                if (yioksRules.password(val)) {
                  if (cPwd) {
                    if (cPwd === val) {
                      cb();
                    } else {
                      cb(new Error("密码不一致"));
                    }
                  } else {
                    cb();
                  }
                } else {
                  cb(new Error("请输入8-16位字符,字母(区分大小写)和数字组合"));
                }
              } else {
                cb(new Error("请输入密码"));
              }
            },
            trigger: "change",
          },
        ],
        cPwd: [
          requiredItem("确认密码"),
          {
            validator: (rule, val, cb) => {
              const { pwd, cPwd } = this.regionForm;
              if (val) {
                if (yioksRules.password(val)) {
                  if (pwd) {
                    if (pwd === val) {
                      cb();
                    } else {
                      cb(new Error("密码不一致"));
                    }
                  } else {
                    cb();
                  }
                } else {
                  cb(new Error("请输入8-16位字符,字母(区分大小写)和数字组合"));
                }
              } else {
                cb(new Error("请输入密码"));
              }
            },
            trigger: "change",
          },
        ],
      };
    },
  },
  created () {
    this.ClubList();
  },
  mounted() {
    this.loadPhotoCode();

    this.setSelectDefault();
  },

  methods: {
    ClubList(){
      common
      .getClubList()
      .then((res) => {
        this.clubOptions = res;
      })
      .catch((err) => {
        console.error("err", err);
      });
    },
    setSelectDefault() {
      // 设置默认上海市
      if (this.select_city_list.length === 1) {
        const defaultCityCode = this.select_city_list[0].code;
        this.$set(this.regionForm, "cityCode", defaultCityCode);
        this.changeCity();
      }
    },
    // 重写方法，别删
    setSelevtProvinceValue() {},
    goBack() {
      // this.$router.back();
      this.isShowCancelConfirm = true;
    },
    changeProvince() {
      if (this.regionForm.provinceCode) {
        this.regions.forEach((item) => {
          if (item.code === this.regionForm.provinceCode) {
            this.cityList = item.city;
            this.$set(this.regionForm, "cityCode", this.cityList[0].code);
            this.$set(this.regionForm, "cityName", this.cityList[0].name);
            this.$set(this.regionForm, "provinceName", item.name);
          }
        });
      } else {
        this.$set(this.regionForm, "cityCode", "");
        this.$set(this.regionForm, "cityName", "");
        this.$set(this.regionForm, "provinceName", "");
        this.cityList = [];
      }
    },
    // 获取图形验证码
    loadPhotoCode() {
      if (this.canImgRefresh) {
        this.canImgRefresh = false;
        const dataForCode = {
          nonce_str: this.nonce_str,
          timestamp: new Date().getTime(),
        };
        common
          .createVerifycode(dataForCode)
          .then((res) => {
            this.canImgRefresh = true;
            const { verificationBase64 } = res;
            if (verificationBase64) {
              this.verificationBase64 = verificationBase64;
            } else {
              console.error("photocode load error");
            }
          })
          .catch((err) => {
            this.canImgRefresh = true;
            console.error("err", err);
          });
      } else {
        this.$message.warning("不要频繁刷新");
      }
    },
    // 发送验证码
    sendPhoneCode() {
      const that = this;
      const { phone, photoCode } = this.regionForm;
      if (!photoCode || !phone) {
        if (!photoCode) this.photoCodeError = "请输入图形验证";
        if (!phone) this.phoneError = "请输入正确的手机号";
        this.loadPhotoCode();
        return;
      }
      this.phoneError = "";
      this.photoCodeError = "";
      if (this.canSendCode) {
        this.canSendCode = false;
        const phoneCodeData = {
          phone,
          nonce_str: this.nonce_str,
          code: photoCode,
        };
        that.timerCount = setInterval(() => {
          that.lastSec--;
          if (that.lastSec <= 0) {
            that.canSendCode = true;
            clearInterval(that.timerCount);
            that.lastSec = defaultSec;
          }
        }, 1000);
        common
          .sendPhoneCode(phoneCodeData)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              that.canSendCode = true;
              this.loadPhotoCode();
              clearInterval(that.timerCount);
              return;
            }
            this.$message.success("验证码发送成功！");
          })
          .catch((err) => {
            that.canSendCode = true;
            that.loadPhotoCode();
            clearInterval(that.timerCount);
            console.error("err", err);
          });
      } else {
        this.$message.warning(`${this.lastSec}秒后可以重新发送`);
        this.loadPhotoCode();
        return;
      }
    },

    changeCity() {
      this.regionForm.cityName = this.select_city_list.find((item) => {
        return item.code === this.regionForm.cityCode;
      }).name;
    },
    changeCounty() {
      this.regionForm.countyName = this.sh_county_list.find((item) => {
        return item.code === this.regionForm.countyCode;
      }).name;
      const { provinceCode, cityCode, countyCode } = this.regionForm;
      if (provinceCode && cityCode && countyCode) {
        this.loadSelectYouthInfo({
          provinceCode,
          cityCode,
          countyCode,
        });
      } else {
        console.warn("请获取精英机构/基地所属信息");
      }
    },

    loadSelectYouthInfo(params) {
      common
        .getYouthListByAddress(params)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.youthSelectList = res;
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    changeOrg() {
      this.regionForm.organShortName = this.youthSelectList.find((item) => {
        return item.uuid === this.regionForm.organUuid;
      }).organShortName;
    },

    handlePageAdd() {
      this.$refs["regionForm"].validate((valid) => {
        if (valid) {
          this.isShowAddConfirm = true;
        }
      });
    },
    handleCancel() {
      this.isShowCancelConfirm = true;
    },

    async hideTipsDialog(ok) {
      if (ok) {
        const {
          accessCode,
          cityCode,
          cityName,
          countyCode,
          countyName,
          provinceCode,
          provinceName,
          idName,
          level,
          loginName,
          organShortName,
          organUuid,
          youthName,
          youthShortName,
          phone,
          photoCode,
          pwd,
        } = this.regionForm;

        // 密码加密
        const publicKey = await auth.getPublicKey(loginName);
        let encryptor = new JSEncrypt();
        encryptor.setPublicKey(publicKey);
        let encryptPassword = encryptor.encrypt(pwd);

        const postData = {
          code: accessCode,
          userForm: {
            idName: idName,
            idNumber: loginName,
            phone: phone,
            password: encryptPassword,
            userStatus: "EFFECTIVE",
          },
          youthForm: {
            adminName: idName,
            cityCode: cityCode,
            cityName: cityName,
            countyCode: countyCode,
            countyName: countyName,
            level: level,
            organUuid: organUuid,
            organShortName: organShortName,
            provinceCode: provinceCode,
            provinceName: provinceName,
            youthName: youthName,
            youthShortName: youthShortName,
          },
        };
        console.log("postData", postData);
        common
          .postRegisFormData(postData)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.isShowSuccessBack = true;
            // this.$message.success("注册成功！");
            // this.$router.push({
            //   path: "/login",
            //   query: {
            //     userName: loginName,
            //   },
            // });
          })
          .catch((err) => {
            console.error("err", err);
          });
      }
      this.isShowAddConfirm = false;
    },

    // 离开页面
    handleConfirmCancel(ok) {
      this.isShowCancelConfirm = false;
      if (ok) {
        this.$router.push({
          path: "/login",
        });
      }
    },

    handleJumpForSuccess() {
      const { loginName } = this.regionForm;
      this.$router.push({
        path: "/login",
        query: {
          userName: loginName,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioksElementUI'
.page-wrapper
  display flex
  align-items center
  justify-content center
  height 100%
  font-size 16px
  .page-content
    // width: calc()
    width 900px
    height 700px
    // display: flex
    // flex-direction: column
    .page-title
      font-size 1.4em
      color #fff
      padding 15px 10px
      background-color $black_color
      display flex
      .icon
        margin-right 10px
        cursor pointer
        user-select none
    .page-airticle
      background-color $black_color
      // flex 1
      height 600px
      margin-top 20px
      box-sizing border-box
      padding 40px 0px 20px 10px
      .scroll-content
        margin 0 20px
    .page-footer
      width 50%
      margin 0 auto
      display flex
      justify-content space-around
      height 100px
      align-items center
.w_input
  // width calc(100% - 260px)
  width 405px
.provinceSettingTra
  display flex
  align-items center
  color #fff
  margin-bottom 22px
  .label
    width 220px
    height 40px
    line-height 40px
    text-align right
    padding-right 5px
    &:before
      content '*'
      color #F56C6C
      margin-right 4px
  /deep/.el-form-item
    margin-bottom 0px
.photocode-box
  width 405px
  display flex
  justify-content space-between
  .left
    width 62%
  .right
    height 40px
    img
      height 40px
      width 120px
    .loadImgIng
      height 40px
      width 120px
      display flex
      align-items center
      justify-content center
    .refresh-code
      cursor pointer
      user-select none
      height 20px
      display flex
      align-items center
      justify-content center
      color #fff
.accesscode-bvox
  width 405px
  display flex
  justify-content space-between
  .left
    width 62%
  .code-btn
    background-color $green_color
    color $white_color
    border-radius 5px
    padding 0 25px
    cursor pointer
    user-select none
  .code-btn-disabled
    cursor text
    background-color #b3e19d
  .right
    .code-err-tips
      position absolute
      bottom -35px
      right 230px
      color #fff
      display flex
      justify-content flex-end
.success-wrapper
  display flex
  flex-direction column
  align-items center
  .icon-img
    width 80px
    height 80px
  .text
    font-size 1.4em
    margin-top 20px
    color #606266
  .action-box
    margin-top 60px
    .btn
      padding 10px 25px
      border-radius 3px
      cursor pointer
      user-select none
      background-color $green_color
      color #fff
      &:hover
        opacity 0.7
</style>
